import { Col, Input, Modal, Row } from "antd";
import React, { useEffect, useState } from "react";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { toast } from "react-toastify";
import { checkAttestationNumber } from "../../../../hooks/useHooks";

const { confirm } = Modal;

const AffecterLotAttestation = ({
  children,
  categories,
  affectationModalOpen,
  handleAffectationModalClose,
  loading,
  onSubmit,
  compagnie,
  categorie,
  typeAttestation,
  nombre,
}) => {
  const [firstAttestation, setFirstAttestation] = useState(0);
  const [lastAttestation, setLastAttestation] = useState(0);
  //  const [nombre, setNombre] = useState(0);
  const [selectedCategorie, setSelectedCategorie] = useState("M");
  const [invalidNumbers, setInvalidNumbers] = useState([]);

  const [selectedTypeAttestation, setSelectedTypeAttestation] =
    useState("SIMPLE");
  const [value, setValue] = useState();
  const [plage, setPlage] = useState([]);

  const handleInputChange = (e) => {
    setValue(e.target.value);
  };

  const parseInput = (input) => {
    const ranges = input?.split(",");

    let result = [];

    ranges?.forEach((range) => {
      const bounds = range.split("-");
      if (bounds.length === 1) {
        const singleValue = parseInt(bounds[0], 10);
        if (!isNaN(singleValue)) {
          result.push(singleValue);
        }
      } else if (bounds.length === 2) {
        const start = parseInt(bounds[0], 10);
        const end = parseInt(bounds[1], 10);

        if (!isNaN(start) && !isNaN(end) && start <= end) {
          for (let i = start; i <= end; i++) {
            result.push(i);
          }
        }
      }
    });

    // Remove duplicates and sort values
    return Array.from(new Set(result)).sort((a, b) => a - b);
  };

  useEffect(() => {
    setPlage(parseInput(value));
  }, [value]);
  console.log("Plage", plage);

  useEffect(() => {
    const verifyNumbers = async () => {
      if (!plage || plage.length === 0) {
        setInvalidNumbers([]);
        return;
      }

      const invalid = [];
      for (const num of plage) {
        try {
          await checkAttestationNumber(num);
        } catch (err) {
          invalid.push(num);
        }
      }
      if (invalid.length) {
        setInvalidNumbers(invalid);
        toast.error(
          `Les numéros suivants sont déjà utilisés: ${invalid.join(", ")}`
        );
      } else {
        setInvalidNumbers([]);
      }
    };
    verifyNumbers();
  }, [plage]);

  const alertDelivery = () => {
    confirm({
      title: "Etes-vous sûr de vouloir effectuer cette livraison?",
      icon: <ExclamationCircleFilled />,
      content: "Toutes vos actions sont historisées!",
      okText: "Oui livrer",
      okType: "danger",
      cancelText: "Annuler",
      onOk() {
        onSubmit(plage, selectedTypeAttestation, selectedCategorie, nombre);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  return (
    <>
      <Modal
        open={affectationModalOpen}
        loading={loading}
        footer={null}
        onOk={() => alertDelivery()}
        okText={"Valider"}
        cancelText={"Annuler"}
        onCancel={() => handleAffectationModalClose(false)}
        zIndex={1900}
        centered
      >
        <div className="text-center mb-6">
          <h4 className="address-title mb-2">
            {" "}
            Affecter un nouveau lot d'attestation pour{" "}
            {compagnie?.raisonSociale}
          </h4>
        </div>
        <form id="addNewAddressForm" className="row g-5" onSubmit={onSubmit}>
          <div className="col-12 col-md-12">
            <div>
              <label>Saisir les numéros d'attestations</label>
              <Input
                value={value}
                onChange={handleInputChange}
                placeholder="e.g., 1-10,12,14,16-30"
                style={{
                  height: 40,
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                }}
              />
            </div>
          </div>
          {/* <div className="col-12 col-md-12">
                    <label class="form-label" for="firstAttestation">
                        Veuillez entrer le numéro de la première attestation
                    </label>
                    <input
                        className="form-control" id="firstAttestation" value={firstAttestation}
                        name="firstAttestation"
                        onChange={(e) => {
                            setFirstAttestation(parseInt(e.target.value));
                            setLastAttestation(parseInt(e.target.value) + nombre - 1);
                        }}
                        placeholder="Entrez le numéro de la première attestation" type="number"/>

                </div>*/}
          <Row
            gutter={5}
            style={{
              background:
                plage?.length === nombre
                  ? "rgba(144, 238, 144, 0.2)"
                  : "rgba(240, 128, 128, 0.2)",
              padding: "10px",
              borderRadius: "5px",
              transition: "background 0.8s ease-in-out",
            }}
          >
            <Col span={12}>
              <label className="form-label" htmlFor="lastAttestation">
                Nombre actuel
              </label>
              <input
                className="form-control"
                id="lastAttestation"
                value={plage?.length}
                name="lastAttestation"
                disabled
                placeholder="Entrez le nombre d'attestation"
                type="number"
                readOnly
              />
            </Col>
            <Col span={12}>
              <label className="form-label" htmlFor="totalAttestation">
                Nombre attendu
              </label>
              <input
                className="form-control"
                id="totalAttestation"
                value={nombre}
                name="totalAttestation"
                placeholder="Entrez le nombre d'attestation"
                type="number"
                disabled
              />
            </Col>
          </Row>
          {/* <div className="col-12 col-md-12">
                    <label class="form-label" for="lastAttestation">
                        Veuillez entrer le numéro de la dernière attestation
                    </label>
                    <input className="form-control" id="lastAttestation" value={lastAttestation}
                           name="lastAttestation" onChange={(e) => setLastAttestation(parseInt(e.target.value))}
                           placeholder="Entrez le numéro de la dernière attestation" type="number"/>
                </div>*/}

          <div className="col-12 col-md-12">
            <label class="form-label" for="agence">
              Attestation sélectionnée
            </label>
            <Input value={`${typeAttestation} - ${categorie?.nom}`} disabled />
          </div>
        </form>
        <div>{children}</div>
        <Row gutter={5}>
          <Col span={12}>
            <div className="text-center mt-5">
              <button
                type="button"
                className="btn btn-secondary"
                style={{ width: "100%" }}
                onClick={() => handleAffectationModalClose(false)}
              >
                Annuler
              </button>
            </div>
          </Col>
          <Col span={12}>
            <div className="text-center mt-5">
              <button
                type="button"
                className="btn btn-primary"
                style={{ width: "100%" }}
                onClick={() => alertDelivery()}
                disabled={invalidNumbers.length > 0}
              >
                Valider
              </button>
            </div>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default AffecterLotAttestation;
